export function DEFAULT_STATE() {
  return {
    stage: null, // 'started', 'dropped', 'canceled'
    cursor: {
      x: null,
      y: null
    },
    item: {
      type: null,
      width: null,
      height: null
    },
    target: {
      current: null
    },
    source: null,
    operation: {
      type: 'clone',
      enableMove: false,
      enableClone: true
    },
    layers: {
      glass: true,
      edgeScrolling: true
    }
  }
}

let state = DEFAULT_STATE()

export function getState() {
  return state
}

export function updateState(updater) {
  state = updater(state) || DEFAULT_STATE()
  return state
}
